import { firestore } from '@src/api/Firebase/Firebase';
import { collection, Timestamp } from 'firebase/firestore';

export enum TableKioskType {
    TABLE = 'table',
    KIOSK = 'kiosk'
}

export enum TableStatus {
    AVAILABLE = 'available',
    ORDER_OPEN = 'orderOpen',
    PAYMENT_REQUESTED = 'paymentRequested'
}

export enum KioskStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}

export interface TableKiosk {
    id?: string;
    name: string;
    type: TableKioskType;
    tableStatus?: TableStatus;
    kioskStatus?: KioskStatus;
    status: boolean;
    branchOfficeId: string;
    createdAt?: Timestamp;
    updatedAt?: Timestamp;
}

export const TABLES_KIOSKS_COLLECTION = 'tables_kiosks';

export const tablesKiosksRef = collection(firestore, TABLES_KIOSKS_COLLECTION);
